import RadarDiagram from "./RadarDiagram";

export default RadarDiagram;